import { useEffect, useState } from "react"

export function useCollapse(cb) {
    const [collapse, setCollapse] = useState(false)

    useEffect(() => {
        if (cb) {
            cb()
        }
    }, [collapse])

    return [
        collapse,
        setCollapse
    ] as const
}